// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"inputCheckbox-module--fieldset--22KXM","checkbox":"inputCheckbox-module--checkbox--jx4WC","checkboxLabel":"inputCheckbox-module--checkboxLabel--1k_cB"};